export enum TrainingStatusModel
{
  Open = 0,
  WaitingComplete = 1,
  Completed = 2,
  Canceled = 3
}
